import { Form, Formik } from "formik";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import useClientes from "~/fetchs/useClientes";
import Select from "~components/Form/components/Select";
import { IconSearch, SearchUser } from "~misc/icons";

const FunnelClientSearch = () => {
  const formikRef = useRef();

  const { clienteSelect, onChangeCliente, handleSearch, options } = useClientes({
    formikRef,
    type: "optionsFunil",
    campo: "cliente",
    enabledRequest: false
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    clienteSelect.upDateValue(e.value);
    clienteSelect.upDateDefaultValue(e || "");

    navigate(`/funil-de-obras/${e.value}`);
  };

  return (
    <div className="container search-container">
      <div className="content">
        <Formik innerRef={formikRef} onSubmit={() => {}}>
          {({ setFieldValue }) => (
            <Form className="input-row">
              <label className="search-select-container">
                <SearchUser className="user-icon" />

                <Select
                  name="cliente"
                  placeholder="Buscar Cliente por quaisquer campos exibidos"
                  options={options}
                  noOptionsMessage="Cliente não encontrado"
                  onChange={handleChange}
                  onInputChange={handleSearch}
                  setFieldValue={setFieldValue}
                  {...clienteSelect}
                />

                <IconSearch className="search-icon" />
              </label>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default FunnelClientSearch;
